import { bullionOddsSnapshotMarkets } from "./bullionOddsSnapshot";
import type { RawMarket, RawMatch } from "./bullionRawMatch";

function frozenMarketsFromMatchRow(match: RawMatch): RawMarket[] {
    const m = match as Record<string, unknown>;
    const snap = m.opening_odds ?? m.openingOdds ?? m.bullionOpeningOdds;
    const fromSnap = bullionOddsSnapshotMarkets(snap) as RawMarket[];
    if (fromSnap.length > 0) return fromSnap;
    // Lobby API also copies the same snapshot onto `markets` when `opening_odds` is set.
    return bullionOddsSnapshotMarkets(m.markets) as RawMarket[];
}

/**
 * Raw markets for the BULLION pick board — frozen prematch `opening_odds` / `odds_snapshot` only.
 * Live Decimal `market_update` is never used here; in-play settlement matches stored
 * `market_id` + `market_line_id` against live feed + settlements API (`bullionSettlementFromDecimalApi.js`).
 */
export function bullionBoardRawMarketsForMatch(match: RawMatch): RawMarket[] {
    return frozenMarketsFromMatchRow(match);
}

/** Board lines from a contest/play `opening_odds` or `odds_snapshot` payload (no live feed merge). */
export function frozenMarketsFromOpeningOddsSnapshot(frozenOdds: unknown): RawMarket[] {
    const frozen = bullionOddsSnapshotMarkets(frozenOdds) as RawMarket[];
    return frozen.length > 0 ? frozen : [];
}
